import { useMutation } from "@tanstack/react-query";
import { useNotification } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { payReferralService } from "./service";
import { PayReferralInput, PayReferralResponse, UsePayReferralMutationOptions } from "./types";

export function usePayReferralMutation(options?: UsePayReferralMutationOptions) {
  const { open } = useNotification();

  return useMutation<PayReferralResponse, ApiError, PayReferralInput>({
    mutationFn: (input: PayReferralInput) => payReferralService(input),
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response?.data?.error ?? "Erro ao pagar indicação",
      });
    },
    ...options,
  });
}
